export default __webpack_public_path__ + "static/media/tesla--white.66d6685d.svg";